const news  = [
    {
        title: 'Transfiere Créditos a tus amigos!',
        titleColor:'warning-dark',
        letter: 'f',
        letterColor: 'warning',
        text:'Desde ahora podrás compartir o comerciar tus créditos con otros jugadores de confianza desde la web, ¿Te falta algo de dinero para un reset? Solicitale a un amigo que te deposite!',
        link:'cuenta'
    },
    {
        title: 'Nueva actualización del cliente!',
        titleColor:'link-dark',
        letter: 'a',
        letterColor: 'link',
        text:'Sigue al día con MU Crisis y sus nuevas actualizaciones, ¿que esperas para descargar el nuevo cliente y continuar tu aventura? Ahora con nuevos contenidos y mapas. Juega YA!',
        link:'jugar'
    },
    {
        title: 'Web Reset',
        titleColor:'white',
        letter: 'r',
        letterColor: 'light',
        text:'Desde ahora pueden realizar los Reset de sus personajes desde la web, y no solo eso, tambien se puede pagar los Resets con Banca Web y Créditos. ¿Qué esperas para probarlo?',
        link:'cuenta'
    },
    {
        title: 'EVENTO: Pelea a muerte con... Cuchillos!',
        titleColor:'white',
        letter: 'e',
        letterColor: 'light',
        text:'Nuevo evento! Batalla campal! todos contra todos con... cuchillos? Sí! cuchillos, solo 1 sobrevivirá y ganará este evento! ¿Qué esperas? Haz clic en el enlace y registrate ya! Tienes chance hasta este sabado.',
        link:''
    },
    {
        title: 'Pase VIP',
        titleColor:'white',
        letter: 'v',
        letterColor: 'light',
        text:'Para aquellos fieles seguidores de MU Crisis les traemos el pase VIP, el cual te ofrecerá muchos beneficios a un módico precio, ¿Qué esperas? Adquierelo YA!',
        link:'cuenta'
    },
    {
        title: 'Sistema de Créditos y Zen Bank',
        letter: 'z',
        titleColor:'white',
        letterColor: 'light',
        text:'Traemos ante ustedes un nuevo sistema de créditos con el cual podrán comprar Zen, Items, Vip y más! También se creó un zen bank para almacenar todo el zen que quieran.',
        link:'cuenta'
    },
    {
        title: 'Nueva Sección: mis Personajes y agregar puntos',
        letter: 'p',
        titleColor:'white',
        letterColor: 'light',
        text:'¡Desde este momento ya puedes ver todos tus personajes creados desde la web! Además que puedes agregarle la cantidad de puntos de nivel que quieras y sin coste alguno, ¡Prueblo ya!',
        link:'cuenta'
    },
    {
        title: 'Ranking de Gremios y Asesinos',
        letter: 'r',
        titleColor:'white',
        letterColor: 'light',
        text:'¡La clasificación de Gremios y Asesinos ya esta aquí! Reune a tus amigos y empieza a escalar posiciones. Sí eres de los que prefiere el pvp puedes intentar entrar entra en la lista de los más buscados.',
        link:'ranking'
    },
    {
        title: 'Actualización del cliente',
        letter: 'c',
        titleColor:'white',
        letterColor: 'light',
        text:'¡Nos enorgullece presentarles la nueva versión de nuestro cliente, Ya disponible para descargar en la sección de jugar!',
        link:'jugar'
    }
]

export default news